import React, { Suspense, lazy } from 'react';
import { HeroSection } from './components/HeroSection';
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const WhatsInsideSection = lazy(() => import('./components/WhatsInsideSection').then(m => ({
  default: m.WhatsInsideSection
})));
const IncludedSection = lazy(() => import('./components/IncludedSection').then(m => ({
  default: m.IncludedSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const CommunityReviewsSection = lazy(() => import('./components/CommunityReviewsSection').then(m => ({
  default: m.CommunityReviewsSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function App() {
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900 selection:bg-yellow-300 selection:text-black" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <Suspense fallback={null} data-id="element-3">
          <div className="section-lazy" data-id="element-4">
            <ProblemSection data-id="element-5" />
          </div>
          <div className="section-lazy" data-id="element-6">
            <SolutionSection data-id="element-7" />
          </div>
          <div className="section-lazy" data-id="element-8">
            <WhatsInsideSection data-id="element-9" />
          </div>
          <div className="section-lazy" data-id="element-10">
            <IncludedSection data-id="element-11" />
          </div>
          <div className="section-lazy" data-id="element-12">
            <BonusSection data-id="element-13" />
          </div>
          <div className="section-lazy" data-id="element-14">
            <TestimonialsSection data-id="element-15" />
          </div>
          <div className="section-lazy" data-id="element-16">
            <PricingSection data-id="element-17" />
          </div>
          <div className="section-lazy" data-id="element-18">
            <GuaranteeSection data-id="element-19" />
          </div>
          <div className="section-lazy" data-id="element-20">
            <CommunityReviewsSection data-id="element-21" />
          </div>
          <div className="section-lazy" data-id="element-22">
            <FAQSection data-id="element-23" />
          </div>
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-24">
        <FooterSection data-id="element-25" />
        <SocialProofPopup data-id="element-26" />
      </Suspense>
    </div>;
}